<template>
  <div>
    <Banner @openCDJS="openCDJS"></Banner>
    <TypeCade></TypeCade>
    <Notice></Notice>
    <div class="xszg" @click="xszgClick">
      <img src="../../assets/img/xszg.jpg" alt="">
    </div>
    <Plans></Plans>
    <CategoryCade v-for="item in categoryList" :category="item" :key="'category'+ item.id"></CategoryCade>
		<div class="mc_cdds" v-if="showCdjs">
        <Cdjs class="Cdjs" @openCDJS="openCDJS"></Cdjs>
    </div>
  </div>
</template>

<script>
  import Banner from './children/banner.vue'
  import TypeCade from './children/typeCade.vue'
  import Notice from './children/notice.vue'
  import Plans from './children/plans.vue'
  import CategoryCade from './children/categoryCade.vue'
  import Cdjs from '../Cdjs/Cdjs.vue'
  import store from '../../vuex/store.js'
  import {ApiGetCategory} from '../../net/home/index.js'
export default {
  data: function () {
    return {
      categoryList: [],
      showCdjs: false,
      xszgUrl: 'http://oeh.qianxunlife.com/'
    }
  },
  store,
  components:{
    Banner,
    TypeCade,
    Notice,
    Plans,
    CategoryCade,
    Cdjs
  },
  computed:{
    isLogin: function () {
      return this.$store.state.isLogin
    }
  },
  methods:{
    getCategory: function () {
      ApiGetCategory().then(res=>{
        if (res.code == 200) {
          this.categoryList = res.value.filter(item=>{
            return item.id != 0
          })
        }
       // console.log('课程6要素', res)
      })
    },
    openCDJS: function () {
      this.showCdjs = !this.showCdjs
    },
    xszgClick () {
      window.open(this.xszgUrl)
    }
  },
  mounted: function () {
    this.getCategory()
  }
}
</script>

<style scoped>
.mc_cdds{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0,0,0,0.6);
  z-index: 999;
}
.Cdjs{
  width: 375px;
  height: 680px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -340px;
  margin-left: -187px;
  background: #fff;
}
.xszg {
  width: 1140px;
  margin: 0 auto;
  margin-top: 40px;
  cursor: pointer;
}
.xszg img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue